const TOGGLE_ICON_TRANSITION_MS = 150;
const containerCls = "_uw7czgpfq2";
const toggleCls = "_uw7tsmkbpn";
const toggleIconCls = "_uw7todvsfh";
const toggleThrobberCls = "_uw7t1cdx5l3";
const progressbarCls = "_uw7pd4h4ow";
const timestampCls = "_uw7t1dqw2hx";

export { TOGGLE_ICON_TRANSITION_MS, containerCls, progressbarCls, timestampCls, toggleCls, toggleIconCls, toggleThrobberCls };
import "./audio-player.style.linaria.module.css";
//# sourceMappingURL=audio-player.style.js.map
